<template>
  <section class="www2">
    <!-- pc -->
    <div class="footer">
      <div class="container">
        <p v-if="!isTXSystem">Copyright © 2018 杭州微易信息科技有限公司. 保留所有权利。 </p>
        <p>ICP备案号：浙ICP备15006271号 - 1 增值电信业务经营许可证：浙B2-20150322 营业执照注册号：913301063961657913 </p>
        <p style="display:none;">
          <a :href="BASE_URL + '/law.html'">隐私政策</a>
          <a :href="BASE_URL + '/legal.html'">法律信息</a>
          <a :href="BASE_URL + '/join.html'">人才招聘</a>
          <a :href="BASE_URL + '/cooperation.html'">联系我们</a>
          <a :href="BASE_URL + '/sitemap.html'">网站地图</a>
        </p>

        <p>本网站用字经北京北大方正电子有限公司授权许可</p>
        <!-- <a :href="BASE_URL + '/about.html'" class="footer1">&nbsp;</a>
        <a :href="BASE_URL + '/about.html'" class="footer2">
          <img style="width:279px;" src="../../images/footer2.png">
        </a> -->
        <a href="javascript:;" class="footer1">&nbsp;</a>
        <a v-if="!isTXSystem" href="javascript:;" class="footer2">
          <img style="width:279px;" src="../../images/footer2.png">
        </a>
        <p style="display:flex;align-items: center;">
          <img src="//media.winbaoxian.com/autoUpload/common/gongan_c6fc55660354ed8.png" style="margin-right:6px;">
          浙公网安备 33010602000620号
        </p>
      </div>
    </div>
    <!-- mobile -->
    <div class="footer-m">
      <div class="sub-menu">
        <ul style="display:none;">
          <li>
            <a :href="BASE_URL + '/index.html'">首页</a>
          </li>
          <li>
            <!-- <a href="https://bxs.winbaoxian.com/insurance-group-pc-new/#/entry" target="_blank">团险</a> -->
            <a href="/#/entry">团险</a>
          </li>
          <li>
            <a :href="BASE_URL + '/cooperation.html'">商务合作</a>
          </li>
          <li>
            <a :href="BASE_URL + '/join.html'">招聘</a>
          </li>
          <li>
            <a :href="BASE_URL + '/about.html'">关于我们</a>
          </li>
        </ul>
      </div>
      <div class="bot">
        Copyright © 2018 杭州微易信息科技有限公司. 保留所有权利。<br> ICP备案号：浙ICP备15006271号 - 1 增值电信业务经营许可证：浙B2-20150322 营业执照注册号：913301063961657913<br> 本网站用字经北京北大方正电子有限公司授权许可
        <br>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'www2-footer',
  props: {
    isTXSystem: {
        default: false
    }
  },
  data() {
    return {
      BASE_URL: 'https://www.winbaoxian.com',
    }
  },
}
</script>

<style lang="less">
@import "../../css/www2";
</style>




// WEBPACK FOOTER //
// src/components/www2/c-footer.vue